package it.unibo.tuprolog.solve.stdlib.rule

import it.unibo.tuprolog.core.Scope
import it.unibo.tuprolog.core.Term
import it.unibo.tuprolog.solve.ExecutionContext
import it.unibo.tuprolog.solve.rule.RuleWrapper
import it.unibo.tuprolog.solve.stdlib.primitive.EnsureExecutable
import kotlin.collections.List as KtList
import kotlin.collections.listOf as ktListOf

object Once : RuleWrapper<ExecutionContext>("once", 1) {
    override val help: String =
        """
        `once(+Goal)`
        
        Calls `Goal` and commits to its first solution, discarding any further alternatives. `Goal` must be executable.

        **Examples**

        ```prolog
        ?- once(member(X, [a, b, c])).
        X = a.

        ?- findall(X, once(member(X, [a, b, c])), L).
        L = [a].

        ?- once(3).
        throws error(type_error(callable, 3), _).
        ```
        """.trimIndent()

    override val Scope.head: KtList<Term>
        get() = ktListOf(varOf("G"))

    override val Scope.body: Term
        get() =
            tupleOf(
                structOf(EnsureExecutable.functor, varOf("G")),
                structOf("call", varOf("G")),
                atomOf("!"),
            )
}
